import { Component } from '@angular/core';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    standalone: false
})
export class DashboardComponent {

  public selected: string = "objects_dashboard";

  public select(name: string) {
    this.selected = name;
  }

  public isSelected(name: string) {
    return name == this.selected;
  }
}
